<template>
    <v-main>
        <DlgMessage ref="dlgMsg" @dlgClose="dlgClose"></DlgMessage>
        <v-container class="fill-height" blue fluid style="height: 100vh;">
            <v-row align="center" justify="center">
                <v-col cols="12" sm="8" md="4">
                    <v-card class="elevation-12">
                        <div class="text-center">
                            <img src="../assets/logo.jpg" height="100px" alt="" class="mt-5">
                        </div>
                        <v-card-text>
                            <h1 class="text-center blue--text text--accent-3">Admin/Client Portal</h1>
                            <v-form class="mt-5" ref="mainForm">
                          <v-text-field
                          v-model="form.login_id"
                            label="Login Id"
                            name="login_id"
                            prepend-icon="mdi-account"
                            type="text"
                            color="blue accent-3"
                            :rules="inputRules"
                          />

                          <v-text-field
                            v-model="form.password"
                            id="password"
                            label="Password"
                            name="password"
                            prepend-icon="lock"
                            :type="showPassword ? 'text' : 'password'"
                            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                            color="blue accent-3"
                             @click:append="showPassword = !showPassword"
                             :rules="inputRules"
                             v-on:keyup.enter="flogin"
                          />
                        </v-form>
                        </v-card-text>
                        <div class="text-center mt-5">
                            <v-btn rounded color="blue accent-3" dark class="mb-3" @click="flogin">LOGIN</v-btn>
                        </div>
                    </v-card>
                </v-col>

            </v-row>
        </v-container>
    </v-main>
</template>

<script>
//import axios from 'axios';
import DlgMessage from '@/components/DlgMessage'
import ApAdminUserService from "@/services/ApAdminUserService"
import ApParameterService from "@/services/ApParameterService"
export default {
    components:{DlgMessage,},
    data(){
        return {
            showPassword:false,
            form:{
                login_id:'',
                password:'',
                platform:'adminportal'
            },
            inputRules: [
             v => !!v || 'This field is required'
            ],
        }
    },
        methods:{
                
        async flogin(){
            if(this.$refs.mainForm.validate()) {
                ApAdminUserService.login(this.form).then((res) => {
                    //console.log(res.data.token_auth);
                    localStorage.setItem('token_auth',res.data.token_auth);
                    localStorage.setItem('loginData',JSON.stringify(res.data.data));
                    localStorage.setItem('login_id',res.data.data.login_id);
                    let loginTmp = res.data.data;
                    if(loginTmp.admin_user_id){
                        //this.$store.dispatch('loginState',true);
                        this.$store.dispatch('aLogin');
                    }
                    //console.log("local storage",localStorage.getItem('token_auth'));
                    // let localLoginData = localStorage.getItem('loginData');
                    // //console.log(localLoginData);
                        
                    this.$router.push('/dashboard')
                    
                     
                }).catch((e)=>{
                    //console.log(e.response.data);
                    if(e.response.data)
                        this.$refs.dlgMsg.showDlgBox(true,'error','Login',e.response.data['error_message']);
                })
                ;


                // try {
                //     const res = await axios.post('ap_admin_user/login', this.form)
                //     localStorage.setItem('token_auth',res.data.token_auth);
                //     localStorage.setItem('loginData',res.data.data);
                //     this.$store.dispatch('loginData',res.data.data);
                //     this.$router.push('/dashboard')

                // } catch(e) {
                //     console.error(e.response.status);
                //     console.error(e.response.data.error_message);
                //     this.error_message = e.response.data.error_message;
                //     this.error_code = e.response.status;
                //     this.$refs.dlgMsg.showDlgBox(true,'error','Login',e.response.data.error_message);
                // }
                
            }            

        },
        dlgClose(){
            this.visible = false;
        },
        async getParameter(){
            try{
                let parameter = {login_id:"",param_type:"member_parameter"}
                ApParameterService.get_parameter_v2(parameter).then((res) => {
                    //console.log(res.data.memberParam);
                    localStorage.removeItem('memberParam');
                    localStorage.setItem('memberParam',JSON.stringify(res.data.memberParam));
                    // let memberParam = JSON.parse(localStorage.getItem('memberParam'));
                    // //console.log(memberParam.mbr_type);
                }).catch((e)=>{
                    if(e)
                        alert("download parameter failed!")
                    //console.log(e,"download parameter error");
                })
                ;
            } catch(e) {
                //console.log(e);
                //this.$refs.dlgMsg.showDlgBox(true,'error','Supplier','Unknown Error');
            }
        },        
    },
    async created() {
      this.getParameter();
    },
}
</script>
